module.exports = __webpack_public_path__ + "f053b2a2e8dc0091af75cfbe7678638d.jpg";